import { i18n } from '@lingui/core';
import * as Cookies from 'js-cookie';
import catalogs, { plurals } from './locale';
export const getCurrentLanguage = () => {
  try {
    var _document, _document$documentEle;
    return ((_document = document) === null || _document === void 0 ? void 0 : (_document$documentEle = _document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.getAttribute('lang')) || Cookies.get('django_language') || 'en';
  } catch (e) {
    return 'en';
  }
};
export const localI18n = setupI18n();
export function setupI18n(locale = getCurrentLanguage(), messages = catalogs) {
  i18n.load(messages);
  i18n.loadLocaleData(plurals);
  i18n.activate(locale);
  return i18n;
}